// components/ModalView.jsx
import React, { useState } from 'react'
import { FaTimes } from 'react-icons/fa'
import { toast } from 'react-toastify'
import api from '../services/api'
//import './ModalView.css'
import './GenericModal-inline.css'

const ModalView = ({
  title,
  initialData,
  fieldsConfig,
  apiEndpoint,
  onClose,
  onSuccess,
  method = 'get'
}) => {
  const [formData, setFormData] = useState(initialData)
  const [loading, setLoading] = useState(false)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = localStorage.getItem('token')
      const user_name = localStorage.getItem('name')

      let response
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }

      if (method === 'put') {
        response = await api.put(
          `${apiEndpoint}/${formData.uuid}/${user_name}`,
          formData,
          config
        )
      } else if (method === 'post') {
        response = await api.post(
          apiEndpoint,
          { ...formData, user_name },
          config
        )
      } else if (method === 'delete') {
        // Pegando o motivo digitado pelo usuário
        const deleteReason = encodeURIComponent(formData.reason)
        response = await api.delete(
          `${apiEndpoint}/${formData.uuid}/${user_name}/${deleteReason}`,
          config
        )
      }

      toast.success(response.data.message || 'Operação realizada com sucesso!')
      onSuccess()
      onClose()
    } catch (error) {
      console.error('Erro na operação:', error)
      toast.error(error.response?.data?.message || 'Erro ao realizar operação')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>
        <div className='modal-header'>
          <h3>{title}</h3>
          <button onClick={onClose} className='modal-close-button'>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className='generic-form'>
          {fieldsConfig.map(field => (
            <div key={field.name} className='form-group'>
              <label htmlFor={field.name}>{field.label}</label>
              {field.type === 'select' ? (
                <select
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  className='form-control'
                  required={field.required}
                  disabled={field.disabled}
                >
                  {field.options.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type || 'text'}
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  className='form-control'
                  required={field.required}
                  disabled={field.disabled}
                  {...field.inputProps}
                />
              )}
            </div>
          ))}

          <div className='form-actions'>
            <button type='button' onClick={onClose} className='cancel-button'>
              Fechar
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ModalView